module.exports = __webpack_public_path__ + "AvertaStd-BlackItalic.svg?23342e3b26b0d505faab806940acdd35";